import { DataSource, TreeSelectOption } from '@qfa/forms';

import {
  useIntersectionsLocationTreeDataSource,
  toSignalLocationOption,
} from './useIntersectionsLocationTreeDataSource';

export const useMainMapEntityListLocationTreeDataSource = (): DataSource<TreeSelectOption[]> => {
  const dataSource = useIntersectionsLocationTreeDataSource({
    centerIds: 'all',
    groupsDisabled: false,
    showDisabledSignals: true,
    toLocationOption: toSignalLocationOption,
  });

  return dataSource;
};
